import Service, { getCallApiFunction } from '../service'
import { USER_ROLE } from '@/types/user-profile'

type ParamsType = {
  followeeId: string
  followerId: string
  followeeType: USER_ROLE
  followerType: USER_ROLE
}
type ResponseType = {
  isSuccess: boolean
}
class DeleteFollowingMemberApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/follow',
      method: 'DELETE',
      params,
    }
  }
}
export const deleteFollowingMember = async (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new DeleteFollowingMemberApi(params))
